import { NativeModulesProxy } from '@unimodules/core';

import { NotificationCategoriesModule } from './NotificationCategoriesModule.types';

export default NativeModulesProxy.ExpoNotificationCategoriesModule as NotificationCategoriesModule;
